import React from 'react';
import { StaticPageLayout } from './StaticPageLayout';
import { ClientTermsContent } from './ClientTermsContent';

export const TermsClientsPage: React.FC = () => (
  <StaticPageLayout
    kicker="Правовая информация"
    title="Пользовательское соглашение"
    documentTitle="QPrice — Пользовательское соглашение"
    updatedAt="25 августа 2026 года"
  >
    <div className="qp-prose">
      <ClientTermsContent />
    </div>
  </StaticPageLayout>
);
